import { Expose } from "class-transformer";

export class UpdateTechnicalReportSectionTextDto {
  @Expose()
  technicalReportId: string;

  @Expose()
  reportSectionId: string;

  @Expose()
  textValue?: string;
}
